import { render, staticRenderFns } from "./BlogComment.vue?vue&type=template&id=4a25fd28&"
import script from "./BlogComment.vue?vue&type=script&lang=js&"
export * from "./BlogComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports